import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { RegisterInvitationsRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { RegisterInvitationsResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const registerInvitations = (request: RegisterInvitationsRequest, options?: CashRequestOptions) =>
  post<RegisterInvitationsRequest, RegisterInvitationsResponse>('/2.0/cash/register-invitations', request, {
    ...options,
    rejectOnError: true,
  })
